import React from "react";
import clsx from 'clsx';
// import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import I18n from "i18n-js";
// import ErrorHelper from "../../Errors/ErrorHelper";

class RoomTypePresenterChannelManagement extends React.Component {

  constructor(props) {
    super(props)
  }


  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'channel_management',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="channel_management">
        {/* {this.renderErrors()} */}
        <div className="row">
          <div className="col-md-12">
            {this.renderGeneralForm()}
          </div>
        </div>
      </div>
    )
  }




  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderGeneralForm() {
    var property_type_description = null
    {this.props.all_property_types.map((property_type) => {
      if (property_type.id == this.props.property_type_id) {
        property_type_description = property_type.description
      }
    })}
    // console.log("property_type", property_type);
    // console.log("this.props.property_type_id", this.props.property_type_id);
    // console.log("all_property_types", this.props.all_property_types);
    return (
      <div>

        <div className="row">
          {this.renderOtaPropertyTypes()}

          <div className="col-md-3">

            <div className="form-group">
              <label>{I18n.t("bedroom_count")}*</label>
              <div>{property_type_description}</div>
              {/* <select
                name="property_type_id"
                value={this.props.property_type_id || ""}
                className={this.renderFieldClasses("property_type")}
                onChange={this.props.onChangePropertyType}
              >
                <option value="" disabled>{I18n.t("select_ellipsis")}</option>
                {this.props.all_property_types.map((property_type) => {
                  return (
                    <option key={property_type.id} value={property_type.id}>
                      {property_type.description}
                    </option>
                  );
                })}
              </select> */}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('days_before_arrival')} <span className="ss-help help" title={I18n.t('days_before_arrival_helper_text')}></span></label>
              <div>{this.props.days_before_arrival}</div>
              {/* <NumberSpinner
                id="days_before_arrival"
                name="room_type[days_before_arrival]"
                value={this.props.days_before_arrival || ''}
                onChange={this.props.onFieldChange}
                hasError={this.renderFieldClasses('maximum_occupancy', true)}
              /> */}
            </div>
          </div>

        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('how_to_arrive')} <span className= "ss-help help" title={I18n.t('how_to_arrive_helper_text')}></span></label>
              <div>{this.props.how_to_arrive}</div>
              {/* <textarea name="room_type[how_to_arrive]" id="how_to_arrive" className={ErrorHelper.renderFieldClasses('how_to_arrive', this.props.errors)} rows={4} value={this.props.how_to_arrive || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('how_to_arrive', this.props.errors)} */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('space')} <span className= "ss-help help" title={I18n.t('space_helper_text')}></span></label>
              <div>{this.props.space}</div>
              {/* <textarea name="room_type[space]" id="space" className={ErrorHelper.renderFieldClasses('space', this.props.errors)} rows={4} value={this.props.space || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('space', this.props.errors)} */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('access')} <span className= "ss-help help" title={I18n.t('access_helper_text')}></span></label>
              <div>{this.props.access}</div>
              {/* <textarea name="room_type[access]" id="access" className={ErrorHelper.renderFieldClasses('access', this.props.errors)} rows={4} value={this.props.access || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('access', this.props.errors)} */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('interaction')} <span className= "ss-help help" title={I18n.t('interaction_helper_text')}></span></label>
              <div>{this.props.interaction}</div>
              {/* <textarea name="room_type[interaction]" id="interaction" className={ErrorHelper.renderFieldClasses('interaction', this.props.errors)} rows={4} value={this.props.interaction || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('interaction', this.props.errors)} */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t('house_rules')} <span className= "ss-help help" title={I18n.t('house_rules_helper_text')}></span></label>
              <div>{this.props.house_rules}</div>
              {/* <textarea name="room_type[house_rules]" id="house_rules" className={ErrorHelper.renderFieldClasses('house_rules', this.props.errors)} rows={4} value={this.props.house_rules || ''} onChange={this.props.onFieldChange} />
              {ErrorHelper.renderFieldErrors('access', this.props.errors)} */}
            </div>
          </div>
        </div>

      </div>
    );
  };

  renderOtaPropertyTypes = () => {
    // const options = this.props.ota_property_types.map(otaPropertyType => <option key={otaPropertyType.id} value={otaPropertyType.id}>{I18n.t(otaPropertyType.description)}</option>)
    return(
      <div className="col-md-3">
        <div className="form-group">
          <label>{I18n.t('ota_property_type')}*</label>
          <div>{this.props.ota_property_type}</div>
          {/* <select
            name="ota_property_type"
            value={this.props.ota_property_type}
            className={this.renderFieldClasses("property_type")}
            onChange={this.props.onChange}
          >
            <option value="" disabled>{I18n.t("select_ellipsis")}</option>
            {options}
          </select> */}
        </div>
      </div>
    );
  };

};

export default RoomTypePresenterChannelManagement
